var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup68(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 62,
    height: 62,
    transform: "translate(0 0)",
    fill: "#152d79"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(-3.037 -3.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(3.037 3.348)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M168.712,91.814a1.55,1.55,0,0,0-1.358-.255l-21.92,6.2a1.551,1.551,0,0,0-1.129,1.492v21a6.2,6.2,0,1,0,3.1,5.369v-18.99l18.818-5.326v12.742a6.2,6.2,0,1,0,3.1,5.369V93.051a1.552,1.552,0,0,0-.616-1.237M141.2,128.723a3.1,3.1,0,1,1,3.1-3.1,3.106,3.106,0,0,1-3.1,3.1m21.92-6.2a3.1,3.1,0,1,1,3.1-3.1,3.106,3.106,0,0,1-3.1,3.1m3.1-24.437-18.818,5.326v-2.98L166.226,95.1Z",
    transform: "translate(-111.544 -74.312)",
    fill: "#152d79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M21.642,11.01a31.169,31.169,0,0,1-7.707-7.637L12.147.691a1.551,1.551,0,0,0-2.841.86V25.857a6.2,6.2,0,1,0,3.1,5.369V6.555a36.621,36.621,0,0,0,7.4,6.957,4.653,4.653,0,0,1-2.747,8.409,1.551,1.551,0,1,0,0,3.1A7.756,7.756,0,0,0,21.642,11.01M6.2,34.328a3.1,3.1,0,1,1,3.1-3.1,3.106,3.106,0,0,1-3.1,3.1",
    transform: "translate(4.845 4.574)",
    fill: "#152d79"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup68);
export default __webpack_public_path__ + "static/media/Group68.09233712d5242fa38c91602928e631ad.svg";
export { ForwardRef as ReactComponent };